import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { RestProvider } from '../../providers/rest/rest';
import { HomePage } from './home';

@NgModule({
  declarations: [
    HomePage,
  ],
  imports: [
    IonicPageModule.forChild(HomePage),
  ],
  providers: [
    RestProvider,
  ]
})
export class HomePageModule {}



// WEBPACK FOOTER //
// ./src/pages/home/home.module.ts